import { useContextSelector } from 'use-context-selector';

import { IThemeContextEquites, ThemeContext } from '@theme/contexts/Theme';

export function useTheme(): IThemeContextEquites {
  const theme = useContextSelector(ThemeContext, cs => cs.theme);

  return { theme };
}
